module.exports = __webpack_public_path__ + "img/Remuneracao.ceb08a8.svg";